import Hero from "../components/Hero";
import CardGrid from "../components/CardGrid";
import { dayTours } from "../data/tours";
import { packages } from "../data/packages";
import "./Home.css";

export default function Home() {
  // Merge all package categories into one array
  const allPackages = Object.values(packages).flat();

  return (
    <>
      {/* Hero section with YouTube video background */}
      <Hero
        title="Savi Guide Tours & Zanzibar Beach Safaris"
        subtitle="Explore Zanzibar and Tanzania with Savi Guide"
        ctaText="View Day Tours"
        ctaHref="/day-tours"
        youtube="F7FDgT2182k"
      />

      {/* Welcome / About Mohammed */}
<section
  className="section welcome"
  style={{
    backgroundImage: "url('/images/sand.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="welcome-grid">
    {/* Left: Savi image */}
    <div className="welcome-image">
      <img
        src="/images/welcoming.jpg"
        alt="Savi guide Tours & Safaris"
      />
    </div>

    {/* Right: Description */}
    <div className="welcome-content">
  <h2>Discover Paradise with Savi Guide Zanzibar Tours & Safaris</h2>

  <p className="welcome-quote">
    “Zanzibar is more than a place — it’s a story, a rhythm, and a dream waiting to be lived.”
  </p>
  <div className="ebant">
  <p>
    I am <strong>Savi Guide</strong>, your dedicated host to the wonders of Zanzibar and Tanzania. 
    With years of experience curating journeys across breathtaking beaches, vibrant Swahili culture, 
    and legendary wildlife safaris, I ensure every adventure is filled with authenticity, joy, and discovery.
  </p>

  <p>
    Together with trusted drivers, expert guides, and handpicked accommodations, 
    I craft experiences that are seamless, safe, and unforgettable. 
    Whether you seek relaxation, thrilling adventures, romantic escapes, or family explorations, 
    my team and I are here to design the journey of your dreams.
  </p>

  <p>
    Karibu sana — a heartfelt welcome to Zanzibar and Tanzania. 
    Let us transform your travel aspirations into cherished memories that last a lifetime.
  </p>

  <p><strong>ZANZIBAR — HAKUNA MATATA, PURE BLISS</strong></p>
  </div>
  </div>
</div>
</section>

      {/* Popular Day Tours */}
      <section className="section">
        <h2>Popular Day Tours</h2>
        <CardGrid items={dayTours.slice(0, 6)} />
      </section>

      {/* Featured Packages */}
      <section className="section">
        <h2>Featured Packages</h2>
        <CardGrid
          items={allPackages.slice(0, 3).map((p) => ({
            ...p,
            cta: { label: "Customize", href: "/contact" }
          }))}
        />
      </section>

      {/* Why Choose Us */}
      <section className="section small">
        <h2>Why Choose Us</h2>
        <div className="features">
          <div className="feature">
            <h3>Local Knowledge</h3>
            <p>
              Born and raised in Zanzibar, we offer authentic experiences guided
              by deep local knowledge.
            </p>
          </div>
          <div className="feature">
            <h3>Flexible Itineraries</h3>
            <p>
              Every tour and safari can be customized to match your interests,
              schedule, and budget.
            </p>
          </div>
          <div className="feature">
            <h3>Trusted Service</h3>
            <p>
              Reliable transfers, comfortable vehicles, professional guides,
              and a safety-first approach.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
